import {useEffect, useRef} from "react";

/**
 * Autofocus an antd Select inside a popover whose content mounts per open
 * (destroyOnHidden). antd's autoFocus prop is unreliable under rc-trigger mount
 * animations, and the Select's search input is remounted during the popup
 * prepare phase — so focus must land late (100ms), when the final node exists.
 * The timer re-arms on every `activate` flip to true (the calling component
 * persists across open/close) and cancels on close/unmount. preventScroll is
 * mandatory: rc popups pre-position off-screen, and a plain focus() would scroll
 * the page to reach the focused node.
 */
export const useAutoFocusRef = (activate?: boolean) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const ref = useRef<any>(null);
  useEffect(() => {
    if (!activate) return; // not armed — don't focus a stale/partial tree
    const timer = setTimeout(() => ref.current?.focus({preventScroll: true}), 100);
    return () => clearTimeout(timer);
  }, [activate]);
  return ref;
};
